import type { HandleClientError } from '@sveltejs/kit';

// Stale-tab recovery — see #73.
// `ChunkLoadError`s thrown by SvelteKit's dynamic imports pass through
// `handleError` on the way to `+error.svelte`. We intercept and reload
// to the intended URL so the user gets the new build instead of an
// error page.

const CHUNK_LOAD_PATTERN =
  /chunk|importing a module|failed to fetch dynamically imported|loading css chunk|loading chunk/i;

let recoveryReloadStarted = false;

function recoverWithReload(target: URL) {
  if (recoveryReloadStarted) return;
  recoveryReloadStarted = true;
  location.assign(target.href);
}

export const handleError: HandleClientError = ({ error, event, status }) => {
  const message = error instanceof Error ? error.message : String(error ?? '');

  if (CHUNK_LOAD_PATTERN.test(message)) {
    recoverWithReload(event.url);
    return { message: 'Updating to latest version…' };
  }

  // Stale `__data.json` 404 after a publish.
  if (status === 404 && /\.json/.test(event.url.pathname)) {
    recoverWithReload(event.url);
    return { message: 'Updating to latest version…' };
  }

  return undefined;
};
